/**
 * Where a half-finished intake is kept between steps and across a killed
 * process: Capacitor Preferences through `src/native` (`localStorage` on the
 * web), behind T25's `IntakeStore` port — the same `KeyValueStorage` shape the
 * locale uses. Non-sensitive: answers, never a credential.
 */
import type { IntakeStore } from "@repo/client/onboarding";
import { preferences } from "../../native";

export const intakeStore: IntakeStore = {
  getItem: (key) => preferences.get(key),
  removeItem: (key) => preferences.remove(key),
  setItem: (key, value) => preferences.set(key, value),
};
